import React from "react";
import classNames from "classnames";
import TimePicker from "rc-time-picker";
import { range } from "lib/utils/socialtravel";
import DeleteRowButton from "./DeleteRowButton";

const addon = (panel) => (
  <div className="rc-time-picker-buttons">
    <a className="rc-time-picker-button rc-time-picker-reset-button" onClick={panel.reset}>
      Wyczyść
    </a>
    <a className="rc-time-picker-button rc-time-picker-ok-button" onClick={panel.close}>
      OK
    </a>
  </div>
);

export default function TimeControl({
  controlRef,
  defaultValue,
  value,
  onFocus,
  onBlur,
  onChange,
  min,
  max,
  step = 60 * 5,
  isTimeBlocked,
  initialValue = value || min || defaultValue || "07:00",
  disabled,
  readOnly,
  includeClearButton = true,
  placement = "bottomLeft",
  ...props
}) {
  const minHour = min ? +min.split(":")[0] : 0;
  const minHourMinutes = min ? +min.split(":")[1] : 0;
  const maxHour = max ? +max.split(":")[0] : 23;
  const maxHourMinutes = max ? +max.split(":")[1] : 59;
  const disabledHours =
    (min || max || step) &&
    (() => {
      return range(0, 24)
        .filter((h) => !(h >= minHour && h <= maxHour))
        .concat(range(0, 24).filter((h) => (h * 3600) % step !== 0));
    });
  const disabledMinutes =
    (min || max || step || isTimeBlocked) &&
    ((h) => {
      const minMinutes = h < minHour ? 60 : h === minHour ? minHourMinutes : 0;
      const maxMinutes = h > maxHour ? -1 : h === maxHour ? maxHourMinutes : 59;
      return range(0, 60)
        .filter((m) => !(m >= minMinutes && m <= maxMinutes))
        .concat(
          isTimeBlocked
            ? range(0, 60).filter((m) => isTimeBlocked(`${h < 10 ? "0" + h : h}:${m < 10 ? "0" + m : m}`))
            : []
        )
        .concat(range(0, 60).filter((m) => (h * 3600 + m * 60) % step !== 0));
    });

  const handleChange = (time) => {
    onChange && onChange(time && time.format(moment.TIME_FORMAT));
  };

  return (
    <div className="TimeControl">
      {!readOnly && (
        <TimePicker
          {...props}
          ref={controlRef}
          defaultValue={defaultValue ? moment(defaultValue, moment.TIME_FORMAT) : undefined}
          defaultOpenValue={moment(initialValue, moment.TIME_FORMAT)}
          value={value ? moment(value, moment.TIME_FORMAT) : null}
          onChange={handleChange}
          onOpen={onFocus}
          onClose={onBlur}
          showSecond={false}
          disabledHours={disabledHours}
          disabledMinutes={disabledMinutes}
          format={moment.TIME_FORMAT}
          placement={placement}
          addon={addon}
          className={classNames("ui input", { readOnly, disabled })}
          placeholder={"__ : __"}
          disabled={disabled}
          hideDisabledOptions
        />
      )}
      {readOnly && (
        <TimePicker
          {...props}
          ref={controlRef}
          defaultValue={defaultValue ? moment(defaultValue, moment.TIME_FORMAT) : undefined}
          value={value ? moment(value, moment.TIME_FORMAT) : null}
          showSecond={false}
          format={moment.TIME_FORMAT}
          className={classNames("ui input", { readOnly, disabled })}
          placeholder={"__ : __"}
          disabled={disabled}
          hideDisabledOptions
          open={false}
        />
      )}
      {!!value && !(readOnly || disabled) && includeClearButton && <DeleteRowButton onClick={() => onChange(null)} />}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/Time.jsx